import {Component, OnInit, Output} from '@angular/core';
import {Restaurant} from "../../shared/model/restaurant";
import {User} from "../../shared/model/user";
import {UserService} from "../../shared/services/user/user.service";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'user-table',
  templateUrl: 'user-table.component.html',
  styleUrls: ['user-table.component.css']
})
export class UserTableComponent implements OnInit {

  private users: User[];

  public rows: Array<any> = [];
  public columns: Array<any> = [
    {
      title: 'First Name',
      name: 'first',
      filtering: {filterString: '', placeholder: 'Filter by first name'},
      sort: 'asc'
    },
    {
      title: 'Last Name',
      name: 'last',
      filtering: {filterString: '', placeholder: 'Filter by last name'},
      sort: 'asc'
    },
/*    {
      title:'Active',
      name:'isActive',
      sort:'asc'
    },*/
    {title: '', ClassName: 'edit', name: 'edit', sort: ''},
  ];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 10;
  public numPages: number = 1;
  public length: number = 0;

  public config: any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
    className: ['table-striped', 'table-bordered' ,'ng-table']
  };

  private data: Array<any>;

  private showSpiner: boolean = false;

  @Output('user')


  private currentRestaurant: Restaurant;
  private currentRestaurantId: string;
   currentRestaurantName: string;


  constructor(
    private userservice:UserService,
    private router:Router,
    private route:ActivatedRoute
  ) {

  }

  ngOnInit() {

    this.data = [];

    let isEmpty:boolean;

    this.route.data
      .subscribe(( data : {restaurant:Restaurant}) =>
      {
        isEmpty = !data.restaurant
        if(!isEmpty){
          this.currentRestaurant = data.restaurant;
          this.currentRestaurantId = data.restaurant.$key;
          this.currentRestaurantName = data.restaurant.restaurant;
          this.userservice.findUsersPerRestaurant(this.currentRestaurantId)
            .subscribe((users) =>{
            this.users = users;
            this.data  = this.users;
            this.length = this.data.length;
            this.onChangeTable(this.config);
              })
        }else {}

      })
  }



  createUser(){


    let navigateRoute = '/users/create/'+this.currentRestaurantId;
    this.router.navigate([navigateRoute])
      .then();

  }





  public onCellClick(data: any): any {




    if (data.column == "edit") {

      let userId = data.row.$key;
      let navigateRoute = '/users/edit/' + userId + '/' + this.currentRestaurantId;
       this.router.navigate([navigateRoute])
         .then();
    }


  }


  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }


  public onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }




}



// WEBPACK FOOTER //
// ./src/app/user/user-table/user-table.component.ts